var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center gap-1 cursor-pointer border-none bg-transparent p-0",on:{"click":_vm.navigate}},[_c('feather-icon',{attrs:{"icon":"ArrowLeftIcon","svgClasses":"h-4 w-4"}}),_vm._v(" "+_vm._s(_vm.label || _vm.$t("buttons.back"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }